export const customerGroupsApi = (client) => ({
    list: (parent_id) => client.get('/api/v1/customer-groups', { params: { parent_id } }).then((r) => r.data),
    tree: () => client.get('/api/v1/customer-groups/tree').then((r) => r.data),
    get: (id) => client.get(`/api/v1/customer-groups/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/customer-groups', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/customer-groups/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/customer-groups/${id}`).then((r) => r.data),
});
//# sourceMappingURL=customer-groups.js.map